import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';
import DoseX from '@/fhirworks/types/DoseX';

export default class DosageDoseAndRate extends BackboneElement {
    static __className = 'DosageDoseAndRate';

    __objectStructure = {
        type: CodeableConcept,
        dose: DoseX,
    };

    constructor(constructJson, className = 'DosageDoseAndRate') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
